import { useState } from 'react';
import { APP_STORE_URL, PLAY_STORE_URL } from '../utils/appLinks';

const DISMISSED_KEY = 'ls-download-banner-dismissed';

const detectPlatform = () => {
  const ua = navigator.userAgent;
  const isIOS = /iPad|iPhone|iPod/.test(ua);
  const isAndroid = /Android/.test(ua);
  // iOS Safari already shows the native Smart App Banner via the apple-itunes-app meta tag
  const isIOSSafari = isIOS && /Safari/.test(ua) && !/CriOS|FxiOS|EdgiOS|OPiOS/.test(ua);
  return { isIOS, isAndroid, isIOSSafari };
};

export const useDownloadBanner = () => {
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem(DISMISSED_KEY) === 'true'
  );

  const { isIOS, isAndroid, isIOSSafari } = detectPlatform();
  const showBanner = (isIOS || isAndroid) && !isIOSSafari && !dismissed;

  const dismiss = () => {
    localStorage.setItem(DISMISSED_KEY, 'true');
    setDismissed(true);
  };

  return {
    showBanner,
    dismiss,
    storeUrl: isAndroid ? PLAY_STORE_URL : APP_STORE_URL,
    storeName: isAndroid ? 'Google Play' : 'the App Store',
  };
};
